videojs.addLanguage('en', {
  "Payment successfully completed": "Payment successfully completed",
  "Access code": "Access code",
  "Access code copy": "Copy",
  "Access code copied": "Copied",
  "Сode copy to have access to the video": "Сode copy to have access to the video"
});